<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">PTMs</h4>
                  <div class="card-body">
                    <p class="inner-lead">At our school, we believe that a strong partnership between parents and teachers is essential for supporting student success. Our PTM programme provides an opportunity for parents and teachers to come together and discuss students' progress, strengths, areas for improvement, and any concerns they may have.</p>
                    <p class="inner-lead">We understand that students thrive when parents and teachers work together in support of their learning and development. Our PTM programme is a key part of our commitment to building strong partnerships between families and educators. These meetings provide an opportunity for parents and teachers to communicate and collaborate on important matters related to student achievement.
                    </p>
                    <p class="inner-lead">By staying informed and involved, parents can play an active role in supporting their child's learning and growth.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>